export const BASE_URL_SERVICE = "https://smartgreen.agrorecomenda.com/api/v1/";
